import { createSlice } from '@reduxjs/toolkit'
import appConfig from 'configs/app.config'

const initialState = {
    currentLang: appConfig.locale,
    searchViewType: 'compact',
    dashboardView: false,
}

export const localeSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLang: (state, action) => {
            state.currentLang = action.payload
        },
        setSearchViewType: (state, action) => {
            state.searchViewType = action.payload
        },
        toggleDashboardView: (state) => {
            state.dashboardView = !state.dashboardView
        },
        resetDashboardView: (state) => {
            state.dashboardView = false
        },
    },
})

export const {
    setLang,
    setSearchViewType,
    toggleDashboardView,
    resetDashboardView,
} = localeSlice.actions

export default localeSlice.reducer
